import React from "react";
import labels from "../translation/index.json";
import {
  AboutTabWrapper,
  AboutTabImageWrapper,
  AboutImageLogo,
  AboutTabTextWrapper,
  AboutVersionWrapper,
  AboutBuildVersionWrapper,
  AboutTabCopyRightWrapper,
  AboutTabTrademarkWrapper,
  AboutTabExternalLink,
  AboutTabHeadingWrapper,
} from "./AboutTabStyled";

const versionNumber = (process.env.REACT_APP_VERSION_NUMBER || "1.0.0").replace(
  "V",
  "",
);
const buildVersion = process.env.REACT_APP_BUILD_NUMBER || "0001";
const currentYear = new Date().getFullYear();
const AboutTab: React.FC = () => {
  return (
    <AboutTabWrapper>
      <AboutTabImageWrapper>
        <AboutImageLogo src="/favicon.ico" alt="Favicon" />
      </AboutTabImageWrapper>
      <AboutTabTextWrapper>
        <AboutTabHeadingWrapper>{labels.aboutTabHeader}</AboutTabHeadingWrapper>
        <AboutVersionWrapper>
          {labels.aboutInfoVersion.replace("$1", versionNumber)}
        </AboutVersionWrapper>
        <AboutBuildVersionWrapper>
          {labels.buildVersion.replace("$1", buildVersion)}
        </AboutBuildVersionWrapper>

        <p>{labels.aboutInfoDetails}</p>
        <AboutTabCopyRightWrapper>
          {labels.copyRightInfo.replace("$1", String(currentYear) || "2025")}
        </AboutTabCopyRightWrapper>
        <AboutTabTrademarkWrapper>
          {labels.trademarksInfo}
        </AboutTabTrademarkWrapper>

        <p>
          {labels.visitWebsiteInfo}{" "}
          <AboutTabExternalLink
            href="http://www.rossvideo.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            {labels.rossWebsite}
          </AboutTabExternalLink>
        </p>
      </AboutTabTextWrapper>
    </AboutTabWrapper>
  );
};

export default AboutTab;
